export enum ExpenseType {
  SalaryCosts = "lønnskostnader",
  Expenses = "utgifter",
  SalaryRoute = "salaryCosts",
  ExpenseRoute = "expenses",
}
